import React from 'react';
import {clearState, setLoginState} from "../store/actions";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate } from 'react-router-dom';

const HeaderTitle = props => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(state => state.login?.isLogin);

  const jumpTo = page => {
    navigate(page);
    return;
  };

  const handleLogout = () => {
    if (window.confirm('ログアウトしますか？')) {
      dispatch(setLoginState(false));
      dispatch(clearState());
      jumpTo("/login");
    }
  };

        return (
          <header className="l-header">
              <div className="l-header__in">
                  <ul className="p-head">
                      <li className="p-head-c">ウロノート</li>

                    {isLoggedIn && (
                    <li className="p-head-r"><a className="p-logout-btn" onClick={handleLogout}><i className="icon icon-logout"></i><span className="p-logout-btn__label">ログアウト</span></a></li>
                    )}

                  </ul>
              </div>
          </header>)
}

export default HeaderTitle;
